module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-thank-you"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "pages-thank-you__container"
  }, [_c('div', {
    staticClass: "pages-thank-you__text"
  }, [_vm._v("Thanks for your submission! We will contact you shortly.")]), _c('router-link', {
    staticClass: "pages-thank-you__return-link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Return to Home Page")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f6a8b32","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/thank-you/thank-you.pug
// module id = 640
// module chunks = 1